const state = {
    purchasedMedia: [
        {
            name: "Streams",
            years: [],
            activeYear: "",
            items: [],
        },
        {
            name: "Courses",
            years: [],
            activeYear: "",
            items: [],
        },
        {
            name: "Backing Tracks",
            years: [],
            activeYear: "",
            items: [],
        },
        {
            name: "Lessons",
            years: [],
            activeYear: "",
            items: [],
        },
        {
            name: "Bundles",
            years: [],
            activeYear: "",
            items: [],
        },
    ],
    orders: [],
    addresses: [],
};

const getters = {
    purchasedMedia: (state) => state.purchasedMedia,
    orders: (state) => state.orders,
    addresses: (state) => state.addresses,
};

const mutations = {
    addPurchasedMedia(state, data) {
        state.purchasedMedia = state.purchasedMedia.map((group) => {
            if (group.name === data.name) {
                return data;
            }

            return group;
        });
    },
    addOrders: (state, data) => {
        state.orders = data;
    },
    setAddresses(state, payload) {
        state.addresses = payload;
    },
    addAddress(state, payload) {
        state.addresses.push(payload);
    },
};

export default {
    namespaced: true,
    getters,
    state,
    mutations,
};
